// extracted by mini-css-extract-plugin
module.exports = {"receipt":"fee-button_receipt__0r3Rg","feeButton":"fee-button_feeButton__4pqxB"};